import React from "react";
import Confetti from "react-confetti";

const Congratulations = () => {
  // const [teamId, setTeamId] = useState("");

  // useEffect(() => {
  //   const storedTeamId = localStorage.getItem("team_id");
  //   setTeamId(storedTeamId);
  // }, []);

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gradient-to-br from-purple-500 to-indigo-600 text-white text-center">
      <Confetti width={window.innerWidth} height={window.innerHeight} />

      <h1 className="text-5xl font-bold animate-bounce">🎉 Congratulations! 🎉</h1>
      {/* {teamId && <p className="text-lg mt-2">Your Team ID: <span className="font-semibold">{teamId}</span></p>} */}
      
      <p className="text-lg mt-4 max-w-md">
        You successfully submitted in Tensor Arena Hackathon !!
        You did an amazing job!
      </p>

      {/* <a
        href="https://forms.gle/TRJgfPw3CX2TzAKM6"
        target="_blank"
        rel="noopener noreferrer"
        className="mt-6 px-6 py-3 bg-yellow-400 text-black font-semibold rounded-lg shadow-lg transition transform hover:scale-105 hover:bg-yellow-300"
      >
        Fill the Google Form 📝
      </a> */}
    </div>
  );
};

export default Congratulations;
